<template>
  <div class="theme-list">
    <p class="title"><i class="iconfont icon-a-close1" @click="closeDialog"></i>知识主题选择</p>
    <div class="scroll-content">
      <div class="library-title ellipsis" @click="initTheme">
        {{libraryInfo.name}}
      </div>
      <div class="tree-list" v-if="!noTheme">
        <Tree
          :data="themeList"
          :load-data="loadThemeTree"
          @on-select-change="handleThemeSelect"
        />
      </div>
      <div class="no-theme" v-if="noTheme">
        <img src="https://p5.ssl.qhimg.com/t110b9a93019a820ae6cc60c7ca.png" alt="">
        <span>暂无知识主题</span>
      </div>
    </div>
  </div>
</template>
<script>
import ajax from '@/utils/ajax'
import { DOCUMENT_TREE } from '@/config/api'
import Tree from '@/components/utils/Tree'
import config from '@/config'
export default {
  name: 'ThemeList',
  props: {
    activeTagList: {
      type: Array,
      default: () => []
    },
    libraryInfo: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Tree
  },
  data () {
    return {
      themeList: [],
      noTheme: false
    }
  },
  created () {
    this.initDocumentTree()
  },
  computed: {

  },
  mounted () {

  },
  methods: {
    initTheme () {
      this.$emit('select-theme', {
        id: '0',
        name: this.libraryInfo.name
      })
    },
    initDocumentTree (document_id) {
      ajax({
        url: DOCUMENT_TREE,
        baseUrl: config.doclib_application_url,
        noPrefix: true,
        data: {
          document_id: document_id || 0,
          is_ancient: false,
          library_id: this.$route.params.library_id || '60b9e001a682ff215188e0d1f44efb41'
        }
      }).then(res => {
        if (res && res.success) {
          let themeList = res.data.map((item) => {
            if (item.item_count > 0) {
              item.children = []
            }
            item.isDoclib = true

            return item
          })
          this.themeList = themeList.concat([])

          if (!themeList.length) {
            this.noTheme = true
          }
        }
      })
    },
    loadThemeTree (document, callback) {
      ajax({
        url: DOCUMENT_TREE,
        baseUrl: config.doclib_application_url,
        noPrefix: true,
        data: {
          document_id: document.id || 0,
          is_ancient: false,
          library_id: this.$route.params.library_id || '60b9e001a682ff215188e0d1f44efb41'
        }
      }).then(res => {
        if (res && res.success) {
          let resDataList = res.data.map((item) => {
            if (item.item_count > 0) {
              item.children = []
            }

            item.isDoclib = true

            return item
          })
          callback(resDataList)
        }
      })
    },
    handleThemeSelect (theme) {
      this.$emit('select-theme', theme[0])
    },
    closeDialog () {
      this.$emit('close-theme-dialog')
    }
  }
}
</script>
<style lang="postcss" scoped>
.theme-list {
  height: 100%;
  box-sizing: border-box;

  & .scroll-content {
    height: calc(100% - 66px);
    overflow: auto;
    box-sizing: border-box;
  }

  & .title {
    display: flex;
    align-items: center;
    color: #1B2532;
    font-family: "PingFang SC";
    font-size: 16px;
    font-style: normal;
    font-weight: 600;
    padding: 20px 16px 20px 20px;
    box-sizing: border-box;

    & i {
      font-size: 24px;
      font-weight: 400;
      margin-right: 8px;
    }
  }

  & .tree-list {
    padding: 0 20px 0 16px;
  }

  & .no-theme{
    height: calc(100% - 108px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: -60px;

    & img {
      width: 220px;
      flex-shrink: 0;
    }

    & span {
      color: #9EA7B8;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 22px;
      margin-top: 4px;
    }
  }

  & .library-title {
    margin-left: 16px;
    margin-right: 20px;
    padding: 0 20px 0 0;
    height: 50px;
    line-height: 50px;
    display: flex;
    font-size: 16px;
    border-bottom: 1px solid #e5e7e9;
  }
}
</style>
